import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="text-2xl font-heading font-bold text-background-50">
                  鲍鱼tv
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                鲍鱼tv是领先的高清视频在线观看平台，提供海量影视、综艺、直播等内容，支持多终端流畅播放，随时随地享受优质视听体验。
              </p>
            </div>

            <div>
              <h4 className="font-medium text-background-50 mb-4">内容分类</h4>
              <ul className="space-y-2">
                {categories.slice(1, 7).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-background-50 mb-4">快捷链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/all"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    全部内容
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-phone-line"></i>
                  <span>400-888-0000</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line"></i>
                  <span>service@baoyutv.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line"></i>
                  <span>中国·北京</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2024-2026 鲍鱼tv baoyutv.com 版权所有 | 京ICP备2024000001号
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://weibo.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-background-500 hover:text-primary-400 transition-colors"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="https://weixin.qq.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-background-500 hover:text-primary-400 transition-colors"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="https://douyin.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-background-500 hover:text-primary-400 transition-colors"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}